import { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const RangeInfo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block" ref={popoverRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="py-2 text-gray-600 text-sm"
      >
        Range Info <FontAwesomeIcon icon={faCircleInfo} size="lg" />
      </button>
      {isOpen && (
        <div
          className="absolute z-50 right-0 mt-2 w-60 bg-white border border-gray-300 rounded-lg shadow-lg p-4"
          style={{
            maxHeight: "none",
            overflow: "visible",
          }}
        >
          <div className="divide-y divide-blue-200 pb-3">Range Info</div>
          <div className="flex flex-row">
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#ED1717] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">0-9 %</p>
              </div>
            </div>
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#DDF969] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">50-59 %</p>
              </div>
            </div>
          </div>
          <div className="flex flex-row mt-2">
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#F24D11] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">10-19 %</p>
              </div>
            </div>
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#A9F36A] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">60-69 %</p>
              </div>
            </div>
          </div>
          <div className="flex flex-row mt-2">
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#F6830C] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">20-29 %</p>
              </div>
            </div>
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#78EC6C] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">70-79 %</p>
              </div>
            </div>
          </div>
          <div className="flex flex-row mt-2">
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#FBB806] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">30-39 %</p>
              </div>
            </div>
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#57E86B] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">80-89 %</p>
              </div>
            </div>
          </div>
          <div className="flex flex-row mt-2">
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#FFEE00] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">40-49 %</p>
              </div>
            </div>
            <div className="basis-2/4">
              <div className="inline-flex items-center">
                <span className="size-3.5 inline-block bg-[#3BCE4F] rounded-full me-2"></span>{" "}
                <p className="text-sm font-light">90-100 %</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RangeInfo;
